const CartIcon = ({
  color = '#A5A5A5',
  width = 35,
  height = 32,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 41 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7534 7.2069V1M19.7534 1L5.56164 6.17241M19.7534 1L33.9452 6.17241M5.56164 6.17241L1 11.8621L5.56164 14.2759M5.56164 6.17241L19.7534 13.4138M19.7534 13.4138L14.6849 19.1034L5.56164 14.2759M19.7534 13.4138L24.8219 19.1034L38 11.8621L33.9452 6.17241M19.7534 13.4138L33.9452 6.17241M19.7534 13.4138V31M19.7534 31L5.56164 24.2759V14.2759M19.7534 31L33.9452 24.2759V14.2759"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default CartIcon
